"use client";

export interface VehicleRVDetailsProps {
  year: number;
  manufacturer: string;
  model: string;
  equipmentType: string;
  sleeps: number;
  length: string;
}

export function VehicleRVDetails({
  year,
  manufacturer,
  model,
  equipmentType,
  sleeps,
  length,
}: VehicleRVDetailsProps) {
  const details = [
    { label: "Year", value: year.toString() },
    { label: "Manufacturer", value: manufacturer },
    { label: "Model", value: model },
    { label: "Equipment Type", value: equipmentType },
    { label: "Sleeps", value: sleeps.toString() },
    { label: "Length", value: length },
  ];

  return (
    <div className="mb-8">
      <h3 className="text-2xl font-semibold mb-4">RV Details</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {details.map((detail, index) => (
          <div key={index} className="flex flex-col">
            <span className="text-muted-foreground text-sm">
              {detail.label}
            </span>
            <span className="font-semibold text-xl">{detail.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
